<template>
    <div id="roleMgt">
        <el-form :inline="true" :model="searchForm">
            <el-form-item label="渠道名：">
                <el-input v-model.trim="searchForm.name" @keyup.enter.native="getRoleHandle" clearable></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="getRoleHandle">搜索</el-button>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="showAddRole">新增渠道</el-button>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="menuEdit">菜单编辑</el-button>
            </el-form-item>
        </el-form>

        <el-table :data="tbpg.tableData" border  >
            <el-table-column type="index" label="序号"></el-table-column>
            <el-table-column prop="id" label="ID" v-if="false"></el-table-column> 
            <el-table-column prop="name" label="渠道名"></el-table-column>
            <el-table-column prop="remark" label="描述"></el-table-column>
            <el-table-column prop="createTime" label="创建时间"></el-table-column>
            <el-table-column prop="stateName" label="状态"></el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button type="text" @click="showEditRole(scope.row.id)">编辑</el-button>
                    <el-button type="text" @click="changeRoleStateHandle(scope.row.id)">{{ showbtnText(scope.row.state) }}</el-button>
                </template>    
            </el-table-column>
        </el-table>
        
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500]"
            :page-size="tbpg.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination>    
        <el-dialog :append-to-body="true"  :title="title" :visible.sync="addRoleVisible" width="600px" @close="cancel" :close-on-click-modal="false">
            <el-form ref="addOrEditRoleForm" :model="addOrEditRoleForm" :rules="addOrEditRoleRules" label-width="100px">
                <el-form-item label="角色名：" prop="name">
                    <el-input v-model.trim="addOrEditRoleForm.name" maxlength="10" clearable></el-input>
                </el-form-item>
                <el-form-item label="描述：" prop="remark">
                    <el-input v-model.trim="addOrEditRoleForm.remark" maxlength="30" clearable></el-input>
                </el-form-item>
                <el-form-item label-width="0" prop="menuIdString" class="roleTabs">
                    <el-tabs tab-position="left">
                        <el-tab-pane v-for="firstMenu in menuList" :label="firstMenu.name" :key="firstMenu.name">
                            <el-checkbox-group v-model="addOrEditRoleForm.menuIdString" v-if="title == '修改角色'">
                                <el-checkbox v-for="secondMenu in firstMenu.nextSysMenuList" :label="secondMenu.id" :key="secondMenu.id">{{ secondMenu.name }}</el-checkbox>
                            </el-checkbox-group>
                            <el-checkbox-group v-model="addOrEditRoleForm.menuIdString" v-else>
                                <el-checkbox v-for="secondMenu in firstMenu.nextAppMenuList" :label="secondMenu.id" :key="secondMenu.id">{{ secondMenu.name }}</el-checkbox>
                            </el-checkbox-group>
                        </el-tab-pane>
                    </el-tabs>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="addOrEidtRoleHandle">确 定</el-button>
            </div> 
        </el-dialog> 

        <!-- 编辑菜单弹窗 -->
        <el-dialog :append-to-body="true"  title="菜单编辑" :visible.sync="menuEditDialog"  @close="cancelmenuEditDialog" :close-on-click-modal="false">
            <el-button type="primary" @click="showAddMenu">添加菜单</el-button>
            <el-table :data="tbpgforEdit.tableData" style="padding-top:20px">
                <el-table-column property="name" label="菜单名称" width="150"></el-table-column>
                <el-table-column property="remark" label="描述" width="150"></el-table-column>
                <el-table-column property="createTime" label="创建时间" width="150"></el-table-column>
                <el-table-column label="状态">
                    <template slot-scope="scope">
                        <span v-if="scope.row.state==1" style="color:green">启用</span>
                        <span v-else-if="scope.row.state==0" style="color:blue">禁用</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button type="text" @click="editMenuVisible(scope.row.id)">编辑</el-button>
                        <el-button type="text" @click="changeMenuStateHandle(scope.row.id)">{{ showbtnText(scope.row.state) }}</el-button>
                    </template>    
                </el-table-column>
            </el-table>
            <el-pagination
            @size-change="handleSizeChangeforEdit"
            @current-change="handleCurrentChangeforEdit"
            :current-page="tbpgforEdit.currentPage"
            :page-sizes="[15, 50, 100, 500]"
            :page-size="tbpgforEdit.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpgforEdit.total">
            </el-pagination> 
        </el-dialog>
        <!-- 编辑菜单详情 -->
        <el-dialog :append-to-body="true"  :title="editTitle" :visible.sync="addMenuVisible" width="600px" @close="canceladdMenuVisible" :close-on-click-modal="false">
            <el-form ref="editMenuDetail" label-width="100px">
                <el-form-item label="菜单名称" prop="name">
                    <el-input v-model.trim="editMenuDetail.name" maxlength="10" clearable></el-input>
                </el-form-item>
                <el-form-item label="一级菜单">
                    <template>
                        <el-select v-model="FirstMenu.id" placeholder="请选择">
                            <el-option
                            v-for="item in FirstMenuList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                            </el-option>
                        </el-select>
                    </template>
                </el-form-item> 
                <el-form-item label="链接路径" prop="linkSrc">
                    <el-input v-model.trim="editMenuDetail.linkSrc" maxlength="30" clearable></el-input>
                </el-form-item>
                <el-form-item label="图片路径" prop="linkSrc">
                    <el-input v-model.trim="editMenuDetail.imgSrc" clearable></el-input>
                </el-form-item>
                <el-form-item label="描述" prop="remark">
                    <el-input v-model.trim="editMenuDetail.remark" maxlength="30" clearable></el-input>
                </el-form-item >
                <el-form-item label="图片" prop="imgSrc" v-if="editMenuDetail.imgSrc !== ''">
                    <div style="float:left;margin-left:10px;position:relative" v-for="(item,index) in tbpgforImg.tableData" :key="index">
                        <el-image
                        style="width: 40px; height: 40px"
                        :src="item"
                        >
                        </el-image>
                        <el-radio v-model="radio" :label="index" @change="getValue"></el-radio>
                        <!-- <div class="overlay"><i class="el-icon-success" style="visibility: hidden;display:color:green;font-size:30px;line-height:100px;margin:0 35px;"></i></div> -->
                    </div>
                </el-form-item>
                <el-form-item  v-if="editMenuDetail.imgSrc !== ''">
                    <el-pagination
                        small
                        @size-change="handleSizeChangeforImg"
                        @current-change="handleCurrentChangeforImg"
                        :current-page="tbpgforImg.currentPage"
                        :page-sizes="[15, 50, 100, 500]"
                        :page-size="tbpgforImg.pageSize"
                        layout="prev, pager, next"
                        :total="tbpgforImg.total">
                    </el-pagination> 
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="canceladdMenuVisible">取 消</el-button>
                <el-button type="primary" @click="updateMenuHandle">确 定</el-button>
            </div> 
        </el-dialog> 
        <!-- 添加菜单 -->
        <el-dialog :append-to-body="true"  title="添加菜单" :visible.sync="showAddMenuDialog" width="600px" @close="canceladdMenuVisible2" :close-on-click-modal="false">
            <el-form ref="addMenuDetail" :model="addMenuDetail" label-width="100px">
                <el-form-item label="菜单名称" prop="name">
                    <el-input v-model.trim="addMenuDetail.name" maxlength="10" clearable></el-input>
                </el-form-item>
                <el-form-item label="一级菜单">
                    <el-select v-model="addMenuDetail.pid" clearable >
                        <el-option v-for="item in FirstMenuList" :value="item.id" :key="item.id" :label="item.name"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="图片路径" prop="imgSrc">
                    <el-input v-model.trim="addMenuDetail.imgSrc" maxlength="30" clearable></el-input>
                </el-form-item>
                <el-form-item label="链接路径" prop="linkSrc">
                    <el-input v-model.trim="addMenuDetail.linkSrc" maxlength="30" clearable></el-input>
                </el-form-item>
                <el-form-item label="描述" prop="remark">
                    <el-input v-model.trim="addMenuDetail.remark" maxlength="30" clearable></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="canceladdMenuVisible2">取 消</el-button>
                <el-button type="primary" @click="addMenuHandles">确 定</el-button>
            </div> 
        </el-dialog> 
    </div>
</template>

<script>
import {addRole, getRoleListPage, editRoleInfo, getOneRoleInfo, changeRoleState, getMenuList, getAllMenuList, getMenuDetail, getFirstMenuList, updateMenu, updateMenuState, addMenuHandle, getAllImage} from '@/api/contract.js'
import common from '@/utils/common.js'
export default {
    data(){
        return {
            searchForm: {
                name: ''
            },
            addOrEditRoleForm: {
                name: '',
                remark: '',            
                menuIdString: []
            },
            title: '新增角色',
            roleId: null,
            addRoleFlag: true,
            menuList: [],
            addRoleVisible: false,
            disable: true,    
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            },
            tbpgforImg: {
                tableData: [],
                currentPage: 1,
                pageSize: 10,
                total: 0
            },
            tbpgforEdit: {
                tableData: [],
                currentPage: 1,
                pageSize: 10,
                total: 0
            },    
            addOrEditRoleRules: {
                name: [
                    {required: true, message: '请输入新增角色名', trigger: 'blur'}
                ],
                menuIdString: [
                    {required: true, message: '请选择至少一个菜单', trigger: 'change'}
                ]
            },

            menuEditDialog: false,
            editTitle: '菜单编辑',
            editMenuList: [],
            addMenuVisible: false,
            editMenuDetail: '',
            FirstMenuList: null,
            FirstMenu: {
                id: '',
                name: ''
            },
            // FirstMenu: {
            //     name : '',
            //     value: ''
            // },
            showAddMenuDialog:false,
            addMenuDetail: {
                name: '',
                pid: '',
                imgSrc:'',
                linkSrc: '',
                remark: ''
            },
            imageList: [],
            radio: null
        }
    },
    methods: {
        cancel(){
            this.addRoleVisible = false;
            this.addRoleFlag = true;
            this.$refs.addOrEditRoleForm.resetFields();  
        },
        showbtnText(state){
            return common.showTxtByState(state, {0: '启用', 1: '禁用'})
        }, 
        getRoleHandle($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);        
            getRoleListPage(data).then(res => {
                common.listCallback(this, res, 'tbpg');
            })
        },
        showAddRole(){
            this.title = '新增渠道';
            this.addRoleVisible = true;
            this.addRoleFlag = true;
            getMenuList().then(res => {
                this.menuList = res.data.data;
            })
        },
        showEditRole(id){
            this.title = '修改角色';
            this.addRoleVisible = true;
            this.addRoleFlag = false;
            this.roleId = id;
            getOneRoleInfo({'id': id}).then(res => {
                var result = res.data;
                this.addOrEditRoleForm.name = result.data.name;
                this.addOrEditRoleForm.remark = result.data.remark;
                this.menuList = result.data.appChannelMenuVoList;

                result.data.appChannelMenuVoList.forEach((firstMenu) => {
                    firstMenu.nextSysMenuList.forEach((secondMenu) => {
                        if(secondMenu['isCheck'] == 1){
                            this.addOrEditRoleForm.menuIdString.push(secondMenu['id'])
                        }
                    })
                })
            })
        },
        addOrEidtRoleHandle(){
            this.$refs.addOrEditRoleForm.validate(valid => {
                if(valid){
                    var data = JSON.parse(JSON.stringify(this.addOrEditRoleForm));
                    data.menuIdString = data.menuIdString.join('|@|');       
                    if(this.addRoleFlag){
                        addRole(data).then(res => callback(res))
                    }else{
                        data.id = this.roleId;
                        editRoleInfo(data).then(res => callback(res))                        
                    }
                }
                var _this = this;
                function callback(res){
                    if(res.data.code == 200){
                        _this.getRoleHandle();
                        _this.addRoleVisible = false;
                        
                    }else{
                        _this.$message.error(res.data.message)
                    }                     
                }
            })
                        
        },
        changeRoleStateHandle(id){
            changeRoleState({'id': id}).then(res => {
                if(res.data.code == 200){
                    this.$message.success(res.data.message)
                    this.getRoleHandle();
                }else{
                    this.$message.error(res.data.message);
                }
            })
        },
        handleSizeChange(val){
            this.tbpg.pageSize = val;
            this.getRoleHandle();
        },
        handleSizeChangeforEdit(val) {
            this.tbpgforEdit.pageSize = val;
            this.menuEdit();
        },
        handleCurrentChange(val){            
            this.tbpg.currentPage = val;
            this.getRoleHandle();
        },
        handleCurrentChangeforEdit() {
            this.tbpgforEdit.currentPage = val;
            this.menuEdit();
        },
        handleSizeChangeforImg(val) {
            this.tbpgforImg.currentPage = val;
            this.getAllImageList();
        },
        handleCurrentChangeforImg(val) {
            this.tbpgforImg.currentPage = val;
            this.getAllImageList();
        },
        getFirstMenuLists() {
            getFirstMenuList().then(res => {
                this.FirstMenuList = res.data.data
            })
        },
        menuEdit($event) {
            this.menuEditDialog = true
            common.resetCurrentPage(this, $event, 'tbpgforEdit');
            var data = common.getRequestParams(this, 'tbpgforEdit', {});        
            getAllMenuList(data).then(res => {
                common.listCallback(this, res, 'tbpgforEdit');
            })
            this.getFirstMenuLists();
        },
        cancelmenuEditDialog() {
            this.menuEditDialog = false
        },
        canceladdMenuVisible() {
            this.addMenuVisible = false
        },
        canceladdMenuVisible2() {
            this.showAddMenuDialog = false
            this.$refs.addMenuDetail.resetFields(); 
        },
        editMenuVisible(id) {
            this.editTitle = '编辑菜单详情',
            this.addMenuVisible = true
            getMenuDetail({'id':id}).then(res => {
                this.editMenuDetail = res.data.data;
                for (let i = 0 ; i < this.FirstMenuList.length ; i++) {
                    if (this.editMenuDetail.pid == this.FirstMenuList[i].id) {
                        this.FirstMenu.id = this.FirstMenuList[i].id;
                        this.FirstMenu.name = this.FirstMenuList[i].name;
                    }
                }
            })
            // getAllImage().then(res => {
            //     this.imageList = res.data.data.resultList;
            //     for (let i = 0 ; i < this.imageList.length ; i++) {
            //         if (this.editMenuDetail.imgSrc == this.imageList[i]) {
            //             this.radio = i
            //         }
            //     }
            // })
            this.getAllImageList()
            
        },
        getAllImageList($event) {
            common.resetCurrentPage(this,$event,'tbpgforImg');
            var data = common.getRequestParams(this,'tbpgforImg',{});
            getAllImage(data).then(res => {
                common.listCallback(this,res,'tbpgforImg');
                for (let i = 0 ; i < res.data.data.resultList.length ; i++) {
                    if (this.editMenuDetail.imgSrc == res.data.data.resultList[i]) {
                        this.radio = i
                    }
                }
            })
        },
        
        showAddMenu() {
            this.showAddMenuDialog = true
        },
        updateMenuHandle() {
            this.editMenuDetail.pid = this.FirstMenu.id;
            updateMenu(this.editMenuDetail).then(res => {
                if(res.data.code == '200') {
                    this.$message.success(res.data.message)
                    getAllMenuList().then(res => {
                        this.editMenuList = res.data.data;
                    })
                    this.FirstMenu.id = '';
                    this.FirstMenu.nam = '';
                    this.addMenuVisible = false
                }
                else{
                    this.$message.error(res.data.message);
                }
            })
        },
        changeMenuStateHandle(id) {
            updateMenuState({'id': id}).then(res => {
                if(res.data.code == 200){
                    this.$message.success(res.data.message)
                    getAllMenuList().then(res => {
                        this.editMenuList = res.data.data;
                    })
                }else{
                    this.$message.error(res.data.message);
                }
            })
        },
        addMenuHandles() {
            addMenuHandle(this.addMenuDetail).then(res => {
                if(res.data.code == 200) {
                    this.$message.success(res.data.message)
                    getAllMenuList().then(res => {
                        this.editMenuList = res.data.data;
                    })
                    this.showAddMenuDialog = false;
                    this.$refs.addMenuDetail.resetFields(); 
                }
                else {
                    this.$message.error(res.data.message);
                }
            })
        },
        getValue(val) {
            this.editMenuDetail.imgSrc = this.imageList[val];
        }
        
    },
    created(){
        this.getRoleHandle();
    }
}
</script>

<style lang="less" >
.roleTabs {
    .el-tabs__content {
        padding-left: 25px;
        label.el-checkbox {
            width: 25%;
        }
    }
    .el-form-item__error {
        left: 140px;
    }
}
.el-radio__label {
    padding-left: 4px;
}
// .overlay {
//     position: absolute;
//     width: 100px;
//     height: 100px;
//     top: 0;
//     left: 0;
//     border-radius: 10px;
//     background-color: rgba(0, 0, 0, .5);
// }
</style>

